import { useEffect, useRef } from "react"
import { useHistory } from "react-router-dom"
import { useGlobalState } from "../Components/GlobalStateProvider"

export function useHrAreaOnly() {
  const { loading, currentUser } = useGlobalState()
  const history = useHistory()
  const stateRef = useRef({ loading, currentUser })
  stateRef.current = { loading, currentUser }

  function checkRoute(location: typeof history.location) {
    const { loading, currentUser } = stateRef.current
    if (!loading && currentUser.id) {
      const matchesRoute = location.pathname.match(/\/hr/)
      if (currentUser.hrAreaOnly && !matchesRoute) {
        history.replace("/hr")
      }
    }
  }

  useEffect(() => {
    checkRoute(history.location)
  }, [currentUser.hrAreaOnly, loading])

  history.listen(location => {
    checkRoute(location)
  })

  return null
}
